import {
  ArrowExitRegular,
  ArrowExitFilled,
  PersonRegular,
  PersonFilled,
  PersonFeedbackRegular,
  PersonFeedbackFilled,
  LeafOneRegular,
  LeafOneFilled,
  FlowRegular,
  FlowFilled,
  BeakerRegular,
  BeakerFilled,
  WeatherSunnyRegular,
  WeatherSunnyFilled,
  WeatherMoonRegular,
  WeatherMoonFilled,
  PanelLeftContractFilled,
  PanelLeftContractRegular,
  PanelLeftExpandFilled,
  PanelLeftExpandRegular,
  PanelRightContractFilled,
  PanelRightContractRegular,
  PanelRightExpandFilled,
  PanelRightExpandRegular,
  ShareFilled,
  ShareRegular,
  SearchFilled,
  SearchRegular,
  CodeRegular,
  CodeFilled,
  DesignIdeasFilled,
  DesignIdeasRegular,
  bundleIcon,
  FolderOpenFilled,
  FolderOpenRegular,
  OpenFilled,
  OpenRegular,
  TreeDeciduousFilled,
  TreeDeciduousRegular,
  TreeEvergreenFilled,
  TreeEvergreenRegular,
  LinkFilled,
  LinkRegular,
  OrganizationHorizontalFilled,
  OrganizationHorizontalRegular
} from "@fluentui/react-icons";

export const Link = bundleIcon(LinkFilled, LinkRegular);
export const OrganizationHorizontal = bundleIcon(OrganizationHorizontalFilled, OrganizationHorizontalRegular);
export const TreeDeciduous = bundleIcon(TreeDeciduousFilled, TreeDeciduousRegular);
export const TreeEvergreen = bundleIcon(TreeEvergreenFilled, TreeEvergreenRegular);
export const FolderOpen = bundleIcon(FolderOpenFilled, FolderOpenRegular);
export const Open = bundleIcon(OpenFilled, OpenRegular);
export const ArrowExit = bundleIcon(ArrowExitFilled, ArrowExitRegular);
export const Code = bundleIcon(CodeFilled, CodeRegular);
export const DesignIdeas = bundleIcon(DesignIdeasFilled, DesignIdeasRegular);
export const Person = bundleIcon(PersonFilled, PersonRegular);
export const PersonFeedback = bundleIcon(
  PersonFeedbackFilled,
  PersonFeedbackRegular
);
export const LeafOne = bundleIcon(LeafOneFilled, LeafOneRegular);
export const Share = bundleIcon(ShareFilled, ShareRegular);
export const Flow = bundleIcon(FlowFilled, FlowRegular);
export const Beaker = bundleIcon(BeakerFilled, BeakerRegular);
export const WeatherSunny = bundleIcon(WeatherSunnyFilled, WeatherSunnyRegular);
export const WeatherMoon = bundleIcon(WeatherMoonFilled, WeatherMoonRegular);
export const PanelLeftContract = bundleIcon(
  PanelLeftContractFilled,
  PanelLeftContractRegular
);
export const PanelLeftExpand = bundleIcon(
  PanelLeftExpandFilled,
  PanelLeftExpandRegular
);
export const PanelRightContract = bundleIcon(
  PanelRightContractFilled,
  PanelRightContractRegular
);
export const PanelRightExpand = bundleIcon(
  PanelRightExpandFilled,
  PanelRightExpandRegular
);
export const Search = bundleIcon(SearchFilled, SearchRegular);

//DEV NOTES:
// 1) It's recommended to create bundleIcons for icons that nest within Fluent components and then import them into your project.
